<script>
import { Line, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

/**
 * 日粒度折线图。vue-chartjs 3.x 用的是组件继承写法（extends: Line），
 * 不是 4.x 的 <Line> 组件写法。
 *
 * reactiveProp 已经声明了 chartData prop 并监听其变化，
 * 这里不能再重复声明 chartData，否则 prop 会被覆盖、切换时间范围时图表不重绘。
 */
export default {
  name: 'DailyTrendChart',
  extends: Line,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
